/* eslint-disable @typescript-eslint/no-unused-vars */
import Loader from 'Components/Common/Loader';
import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';

import wrongIcon from '../../assets/images/commons/WrongIcon.svg';
import Checkbox from 'Components/DynamicComponents/Checkbox';
import { useFormik } from 'formik';
import {
    filterValidParams,
    formatDateToDDMMMYYYY,
    generateInitialValues,
    generateValidationSchema,
    trimValues
} from 'Components/Common/Util';
import * as Yup from 'yup';
import BreadCrumb from 'Components/Common/BreadCrumb';
import * as url from '../../../src/helpers/url_helper';
import withRouter from 'Components/Common/withRouter';
import { CONSTANTS } from 'Components/constants/appConstants';

const ViewUser = (props: any) => {
    const api = props?.router?.apiClient;
    const [loading, setLoading] = useState<boolean>(false);

    const [userData, setUserData] = useState<any>({});

    const recordID = window.location.hash?.split('/')?.reverse()?.[0];

    const [areaDetails, setAreaDetails] = useState<any>([]);
    const [mineDetails, setMineDetails] = useState<any>([]);

    const [privileges, setPrivileges] = useState<any>([
        {
            label1: 'View',
            value: 'view',
            inputType: 'checkbox',
            type: 'checkbox',
            checked: true,
            disabled: true,
            mandatory: false,
            isVisible: true,
            lg1: 12
        },
        {
            label1: 'Create',
            value: 'create',
            inputType: 'checkbox',
            type: 'checkbox',
            checked: true,
            disabled: true,
            mandatory: false,
            isVisible: true,
            lg1: 12
        },
        {
            label1: 'Edit',
            value: 'edit',
            inputType: 'checkbox',
            type: 'checkbox',
            checked: true,
            disabled: true,
            mandatory: false,
            isVisible: true,
            lg1: 12
        },
        {
            label1: 'Delete',
            value: 'delete',
            inputType: 'checkbox',
            type: 'checkbox',
            checked: true,
            disabled: true,
            mandatory: false,
            isVisible: true,
            lg1: 12
        },
        {
            label1: 'Upload',
            value: 'upload',
            inputType: 'checkbox',
            type: 'checkbox',
            checked: true,
            disabled: true,
            mandatory: false,
            isVisible: true,
            lg1: 12
        },
        {
            label1: 'Reupload',
            value: 'reUpload',
            inputType: 'checkbox',
            type: 'checkbox',
            checked: true,
            disabled: true,
            mandatory: false,
            isVisible: true,
            lg1: 12
        },
        {
            label1: 'Download',
            value: 'download',
            inputType: 'checkbox',
            type: 'checkbox',
            checked: true,
            disabled: true,
            mandatory: false,
            isVisible: true,
            lg1: 12
        }
    ]);

    const [role, setRole] = useState<any>([]);

    const validation: any = useFormik({
        enableReinitialize: false,
        initialValues: generateInitialValues(privileges),
        validationSchema: generateValidationSchema(privileges, Yup),
        validate: (values) => trimValues(values, privileges),
        onSubmit: (values) => {}
    });

    useEffect(() => {
        if (recordID) {
            const filterPayload = {
                textSearch: '',
                userRef: recordID
            };

            const filters = filterValidParams(filterPayload);

            const payLoad = {
                params: {
                    search: JSON.stringify(filters),
                    page: 1,
                    size: 1
                }
            };
            setLoading(true);
            api?.get(`${url?.GET_USERS}`, payLoad)
                .then(async (resp: any) => {
                    if (resp?.status?.toLowerCase() === 'success') {
                        const userData = resp?.data?.data?.[0];
                        setUserData(userData);
                        const roles = userData?.userProfile?.roles?.map((r: any) => r.role) || [];
                        setRole(roles);

                        setAreaDetails(userData?.userProfile?.roles?.flatMap((roleItem: any) => roleItem?.areaIds)?.filter(Boolean));
                        setMineDetails(
                            userData?.userProfile?.roles
                                ?.flatMap((roleItem: any) => roleItem?.areaIds)
                                ?.flatMap((item: any) => item?.mines)
                                ?.filter(Boolean)
                        );

                        const allPrivileges = userData?.userProfile?.roles?.flatMap((roleItem: any) =>
                            (roleItem?.privileges || []).map((priv: any) => ({
                                privilege: priv,
                                roleName: roleItem?.name
                            }))
                        );

                        const formattedPrivileges = allPrivileges.map((item: any) => ({
                            label1: item.privilege?.replaceAll('_', ' '),
                            value: item.privilege,
                            roleName: item.roleName?.replaceAll('_', ' '),
                            inputType: 'checkbox',
                            type: 'checkbox',
                            checked: true,
                            disabled: true,
                            mandatory: false,
                            isVisible: true,
                            lg1: 12
                        }));

                        setPrivileges(formattedPrivileges);

                        setPrivileges(formattedPrivileges);

                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                })
                .catch(() => {
                    setLoading(false);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordID]);

    return (
        <React.Fragment>
            <div className="page-content">
                {loading && <Loader />}
                <BreadCrumb
                    subTitle={[
                        { label: 'User Management', link: '/user-management' },
                        { label: 'All User', link: '/user-management' },
                        { label: 'View User', link: '/user-management' }
                    ]}
                />
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="p-4">
                                    <Row>
                                        <Col>
                                            <div className="mb-4 font-weight-600 font-size-18">User Details</div>
                                        </Col>
                                    </Row>

                                    <Row className="gx-5 gy-3">
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Emp ID</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">{userData?.empId}</div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">User Name</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {userData?.firstName + ' ' + userData?.lastName}
                                            </div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Email ID</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">{userData?.email}</div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">
                                                Contact Number
                                            </div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {userData?.phoneNumber?.code + ' ' + userData?.phoneNumber?.value}
                                            </div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Address</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">{userData?.address}</div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Role</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {Array.isArray(userData?.userProfile?.roles)
                                                    ? userData?.userProfile?.roles
                                                          ?.map(
                                                              (roleItem: any) =>
                                                                  roleItem?.role?.replaceAll('_', ' ')?.slice(0, 1)?.toUpperCase() +
                                                                  roleItem?.role?.replaceAll('_', ' ')?.slice(1)?.toLowerCase()
                                                          )
                                                          .join(', ')
                                                    : ''}
                                            </div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Created By</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">{userData?.createdBy}</div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">
                                                Created Date
                                            </div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {formatDateToDDMMMYYYY(userData?.createdAt)}
                                            </div>
                                        </Col>
                                    </Row>

                                    {Array.isArray(role) &&
                                        role.map((r) => r.trim()).some((r) => r === 'USER' || r === 'NODAL_OFFICER') && (
                                            <>
                                                <Row>
                                                    <Col className="gy-3">
                                                        <div className="mb-4 font-weight-600 font-size-18">Area Details</div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg={12}>
                                                        <div>
                                                            <div className="d-flex flex-wrap gap-2 mb-2">
                                                                {areaDetails?.map((area: any, ind: number) => {
                                                                    return (
                                                                        <span
                                                                            key={ind}
                                                                            className="font-size-14 font-weight-500 line-height-20 br-8 bg-light-sky-100 p-8 px-2 height-36 text-center d-flex justify-content-center align-items-center"
                                                                        >
                                                                            {area?.areaName}
                                                                            <img
                                                                                alt={'wrong-icon'}
                                                                                src={wrongIcon}
                                                                                className="ms-2"
                                                                                height={14}
                                                                                width={14}
                                                                            />
                                                                        </span>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}

                                    {Array.isArray(role) && role.map((r) => r.trim()).some((r) => r === 'USER') && (
                                        <>
                                            <Row>
                                                <Col className="gy-3">
                                                    <div className="mb-4 font-weight-600 font-size-18">Mine Details</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={12}>
                                                    <div>
                                                        <div className="d-flex flex-wrap gap-2 mb-2">
                                                            {mineDetails.length > 0
                                                                ? mineDetails?.map((mine: any, ind: number) => {
                                                                      return (
                                                                          <span
                                                                              key={ind}
                                                                              className="font-size-14 font-weight-500 line-height-20 br-8 bg-light-sky-100 p-8 px-2 height-36 text-center d-flex justify-content-center align-items-center"
                                                                          >
                                                                              {mine?.mineName}
                                                                              <img
                                                                                  alt={'wrong-icon'}
                                                                                  src={wrongIcon}
                                                                                  className="ms-2"
                                                                                  height={14}
                                                                                  width={14}
                                                                              />
                                                                          </span>
                                                                      );
                                                                  })
                                                                : '-'}
                                                        </div>

                                                        {/* Label and Dropdown */}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </>
                                    )}

                                    <Row>
                                        <Col className="gy-3">
                                            <div className="mb-4 font-weight-600 font-size-18">Privilege Details</div>
                                        </Col>
                                    </Row>

                                    <Row className="gx-5 gy-3 mb-5">
                                        {privileges?.map((privilege: any, index: number) => (
                                            <Col key={index} md={6} lg={4}>
                                                <Checkbox field={privilege} validation={validation} mode="" checked={true} />
                                            </Col>
                                        ))}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(ViewUser);
